import i18next from 'i18next';
import { ApiClientExceptionErrorCode, IApiClientException } from 'types/api';

/**
 * Étend `Error` : indispensable pour Sentry. Un objet non-Error capturé via
 * `captureException` donne un event illisible (« Object captured as exception
 * with keys: Code, ErrorCode, Message, errors », titré du nom minifié de la
 * fonction appelante, ex. « gn »). En étendant Error, l'event devient
 * `ApiClientException: <Message>` avec une vraie stacktrace.
 */
export class ApiClientException extends Error implements IApiClientException {
  errors: never[] | undefined;
  constructor(
    public Message: string,
    public Code: number,
    public ErrorCode: ApiClientExceptionErrorCode,
  ) {
    super(Message);
    this.name = 'ApiClientException';
  }

  public getMessage() {
    if (i18next.exists(`errors.${this.ErrorCode}`)) {
      return i18next.t(`errors.${this.ErrorCode}`);
    }

    if (i18next.exists(`errors.${this.Message}`)) {
      return i18next.t(`errors.${this.Message}`);
    }

    return this.Message;
  }
}
